// 서비스
export default {
  path: '/:locale([en]*)?/service/:child?',
  name: 'Service',
  component: () => import('@/views/service/Index'),
  meta: {
    scroll: true,
    sitemap: {
      loc: '/service'
    }
  }
}
